import { HttpUrlEncodingCodec } from '@angular/common/http';

/**
 * @description Implementation of the HttpUrlEncodingCodec interface for encoding and decoding raw HTTP parameter keys and values.
 */
export class RawHttpParamsEncoder implements HttpUrlEncodingCodec {
  public encodeKey(key:string):string {
    return key;
  }

  public decodeKey(key:string):string {
    return key;
  }

  public encodeValue(value:string):string {
    return value
      // preserve some characters
      .replace(/%40/g, '@')
      .replace(/%2C/g, ',');
  }

  public decodeValue(value:string): string {
    return value;
  }
}